export default __webpack_public_path__ + "static/media/app-menu-apple.a65d5b88.webp";